import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 10000,
  withCredentials: true,
});


// User API endpoints
export const registerUser = async (userData) => {
  try {
    const response = await api.post('/user/register', userData);

    // Check if the response indicates success
    if (response.data.success) {
      return {
        success: true,
        user: response.data.user,
        message: response.data.message,
      }
    } else {
      // If success is false, return the error
      return {
        success: false,
        message: response.data.message,
      }
    }
  } catch (error) {
    // Handle both axios error structure and custom errors
    const errorMessage = error.response?.data?.message || error.message || 'Registration failed';

    return {
      success: false,
      message: errorMessage
    };
  }
};


export const loginUser = async (email, password) => {
  try {
    console.log('Starting Login');
    const response = await api.post('/user/login', { email, password });

    // Check if user requires verification
    if (response.data.requiresVerification) {
      console.log('User requires email verification');
      return {
        success: false,
        requiresVerification: true,
        userId: response.data.userId,
        email: response.data.email,
        message: response.data.message,
      };
    }

    if (response.data.success) {
      return {
        success: true,
        user: response.data.user,
        requiresVerification: false,
      };
    }

    if (!response.data.success) {
      console.log(response.data.message);
      return {
        success: false,
        message: response.data.message,
        requiresVerification: false,
      };
    }

  } catch (error) {
    console.log('Login error:', error); // Debug log

    let errorMessage = 'Login failed';
    let requiresVerification = false;
    let userId = null;
    let userEmail = null;

    if (error.response) {
      console.log('Error response data:', error.response.data);
      errorMessage = error.response.data.message || errorMessage;

      // Check if the error is due to unverified email
      if (error.response.data.requiresVerification) {
        requiresVerification = true;
        userId = error.response.data.userId;
        userEmail = error.response.data.email;
        errorMessage = error.response.data.message;
      }
    } else if (error.request) {
      console.log('No response received:', error.request);
      errorMessage = 'No response from server';
    } else {
      console.log('Error setting up request:', error.message);
      errorMessage = error.message;
    }

    return {
      success: false,
      message: errorMessage,
      requiresVerification: requiresVerification,
      userId: userId,
      email: userEmail,
    };
  }
};


//Logout User
export const logoutUser = async() => {
  try {
    const response = await api.post('/user/logout');
    if(response){
      return {
        success: true,
      };
    }else{
      console.log('Error Processing Logout');
    }

  } catch (error) {
    console.error(error);
    let errorMessage = 'Logout Failed';
    return {
      success: false,
      message: errorMessage
    }
  }
}


export const verifyUserEmail = async(userId, code) => {
  try {
    const response = await api.put(`/user/verify-user-email/${userId}`, { code });
    return {
      success: response.data.success,
      message: response.data.message,
    }
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
}


export const resendVerificationCode = async(userId) => {
  try {
    const response = await api.post(`/user/resend-verification-code/${userId}`);
    return {
      success: response.data.success,
      message: response.data.message,
    }
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
}

export const forgotPassword = async (email) => {
  try {
    const response = await api.post('/user/forgot-password', { email });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to send reset email');
  }
};

export const resetPassword = async (token, password) => {
  try {
    const response = await api.post(`/user/reset-password/${token}`, { password });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to reset password');
  }
};